import { builBackendTableQuery } from "functions/backend/backendTableQueryBuilder"

export const queryDifferenceChecker = ({ newQueryData, lastQueryData }) => {

    const newQueryString = builBackendTableQuery(newQueryData)
    const lastQueryString = builBackendTableQuery(lastQueryData)
    const isStringDifferent = newQueryString !== lastQueryString
    // console.log({newQueryString, lastQueryString, isStringDifferent})

    return isStringDifferent
}
